<div class="container-fluid bg-lightblue pb-5" *ngIf="!isNull">
    <div class="container-xxxl">
        <hr class="m-0 d-print-none" />

        <div class="inheritance-section pt-5">
            <causes-tabs [articles]="articles" [mainArticle]="mainArticle"></causes-tabs>
        </div>
    </div>
</div>
